<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.3 14.3">
        <line x1="8" y2="8" transform="translate(7.157 1.5) rotate(45)" fill="none" stroke="currentColor"  stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
    </svg>
</template>
